import gql from 'graphql-tag';

export const NAME = 'setup_ResourceErrorBoundary_resourceCheck';

export default gql`
  query ${NAME} ($caseNumber: String!) {
    case(caseNumber: $caseNumber) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/setup/ResourceErrorBoundary/caseResourceCheckQuery.js